import React, {FC} from 'react';

import {Anchor} from '../../../../../libs/shared/ui/src/components/reposition/repositionHelpers';
import {SandboxScenariosEnum} from '../../../../helpers/sandbox/sandboxScenarioHelpers';
import {OpenStatusEducationTip} from './openStatusEducationTip';
import {SandboxEducationTipCoordinator} from './sandboxEducationTipCoordinator';

interface TicketStatusEducationTipCoordinatorProps {
  anchor: Anchor;
  conversationId: number | undefined;
}

export const OpenStatusEducationTipCoordinator: FC<TicketStatusEducationTipCoordinatorProps> = (props) => (
  <SandboxEducationTipCoordinator
    anchor={props.anchor}
    conversationId={props.conversationId}
    scenario={SandboxScenariosEnum.SCENARIO5_ACT1}
    step="ticket-status-open"
    isEligible
    renderEducationTip={(tipProps) => <OpenStatusEducationTip {...tipProps} />}
  />
);
